import React from 'react';
import classnames from 'classnames';

import CheckMarkSVG from '../../../../images/svg/icons8-checkmark';
import './_oe-multi-select-item.scss';
import { MultiSelectOption } from '../../multi-select-list/_multi-select-option';
import Text from '../../text/text';

interface IProps {
    label: string;
    id: string;
    value: string;
    withCheckmark?: boolean;
    isSelected: boolean;
    isDisabled?: boolean;
    withCheckbox?: boolean;
    onChange: (v: string) => void;
}

const OEMultiSelectItem = (props: IProps) => {
    const { label, id, value, onChange, withCheckmark, withCheckbox, isSelected, isDisabled } = props;

    return (
        <div
            key={value}
            className={classnames('multi-select__option', {
                'multi-select__option--selected': isSelected,
                'multi-select__option--disabled': isDisabled,
            })}
            onClick={() => !isDisabled && onChange(value)}
        >
            {
                withCheckmark && <div className={classnames('multi-select__checkmark', {
                    'multi-select__checkmark--selected': isSelected
                })}>
                    <CheckMarkSVG />
                </div>
            }
            {
                withCheckbox && <MultiSelectOption
                    isSelected={isSelected}
                    isDisabled={isDisabled}
                />
            }
            <Text
                tag='div'
                className='multi-select__label'
                id={id}
                message={label}
                description='Issue button text'
                withEllipsis
            />
        </div>
    );
};

export default OEMultiSelectItem;
